<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M22,4H14L12,2H6A2,2 0 0,0 4,4V16A2,2 0 0,0 6,18H22A2,2 0 0,0 24,16V6A2,2 0 0,0 22,4M2,6H0V11H0V20A2,2 0 0,0 2,22H20V20H2V6Z"/>
    </svg>
</template>

<script>
export default {
    name: 'FolderMultipleIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
